"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Tooltip = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _CoreTooltip = require("../internal/WixUiCoreComponents/components/CoreTooltip");
var _Arrows = require("./Arrows");
var _TooltipSt = require("./Tooltip.st.css");
var _types = require("./types");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/Tooltip/Tooltip.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function customArrow(placement, arrowProps) {
  const ArrowSvg = (0, _Arrows.getArrowByPlacement)(placement);
  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: _TooltipSt.classes.tpaArrow
  }, arrowProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(ArrowSvg, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 7
    }
  }));
}
class Tooltip extends React.Component {
  render() {
    const {
      className,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(_CoreTooltip.CoreTooltip, (0, _extends2.default)({
      className: (0, _TooltipSt.st)(_TooltipSt.classes.root, {
        skin: this.props.skin
      }, className),
      timeout: {
        enter: 120,
        exit: 80
      },
      customArrow: customArrow
    }, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 7
      }
    }));
  }
}
exports.Tooltip = Tooltip;
(0, _defineProperty2.default)(Tooltip, "displayName", 'Tooltip');
(0, _defineProperty2.default)(Tooltip, "defaultProps", {
  skin: _types.TooltipSkin.Standard,
  maxWidth: 240
});
//# sourceMappingURL=Tooltip.js.map